import React from "react";

const Invoice = () => {
return(
    <h1>New Opd</h1>
)
}

export default Invoice;